export const BASE_DELAY_MS = 200;
export const MAX_NUMBER_OF_RETRIES = 3;
export const TIMEOUT = 10000;
export const MAX_LENGTH_OF_YIELDS = 2;
